import { useEffect, useRef, useState, useImperativeHandle } from 'react';
var useToggleDrawer = function (initState, ref, triggerElements, reloadPageOnClose) {
    var drawerRef = useRef(null);
    var _a = useState(initState), show = _a[0], setShow = _a[1];
    var _b = useState('visible'), initialBodyOverflowX = _b[0], setInitialBodyOverflowX = _b[1];
    var _c = useState('visible'), initialBodyOverflowY = _c[0], setInitialBodyOverflowY = _c[1];
    //  There will most likely be multiple triggers on the page, used to track which element triggered.
    var _d = useState(undefined), trigger = _d[0], setTrigger = _d[1];
    var handleClickOutside = function (event) {
        // if drawer is open and click is outside drawer, close it
        if (drawerRef.current && !drawerRef.current.contains(event.target)) {
            handleClickClose();
        }
    };
    var handleVisibilityChange = function () {
        if (document.hidden) {
            handleClickClose();
        }
    };
    var handleClickOpen = function (dataId, elementId) {
        setShow(true);
        // Lock scrolling outside element when open.
        document.body.style.overflow = 'hidden';
        document.body.setAttribute('inert', 'true');
        // Set which element triggered the opening so focus can be returned when drawer closed.
        if (Array.isArray(triggerElements.current)) {
            setTrigger(triggerElements.current.find(function (el) { return el.id === elementId; }));
        }
        else {
            // eslint-disable-next-line @typescript-eslint/non-nullable-type-assertion-style
            setTrigger(triggerElements.current);
        }
    };
    var handleClickClose = function () {
        setShow(false);
        if (reloadPageOnClose)
            window.location.reload();
        // Return scrolling outside element when closed.
        document.body.style.overflow = "".concat(initialBodyOverflowX, " ").concat(initialBodyOverflowY);
        document.body.removeAttribute('inert');
        if (trigger) {
            trigger.focus();
        }
    };
    var handleKeyDown = function (event) {
        if (event.key === 'Escape') {
            event.stopPropagation();
            handleClickClose();
        }
    };
    // Allows outside elements to open and close node.
    useImperativeHandle(ref, function () { return ({
        openDrawer: function (dataId, elementId) {
            handleClickOpen(dataId, elementId);
        },
        closeDrawer: function () {
            handleClickClose();
        }
    }); });
    useEffect(function () {
        // Close drawer clicking outside of drawer.
        document.addEventListener('click', handleClickOutside, true);
        // Close drawer with esc.
        document.addEventListener('keydown', handleKeyDown, true);
        // Close drawer on browser tab change.
        document.addEventListener('visibilitychange', handleVisibilityChange, true);
        window.addEventListener('blur', handleClickClose);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
            document.removeEventListener('keydown', handleKeyDown, true);
            document.removeEventListener('visibilitychange', handleVisibilityChange, true);
            window.removeEventListener('blur', handleClickClose);
        };
    }, []);
    useEffect(function () {
        setInitialBodyOverflowX(getComputedStyle(document.body).overflowX);
        setInitialBodyOverflowY(getComputedStyle(document.body).overflowY);
    }, []);
    return {
        drawerRef: drawerRef,
        show: show,
        handleClickClose: handleClickClose,
        handleKeyDown: handleKeyDown,
        trigger: trigger,
        setShow: setShow
    };
};
export default useToggleDrawer;
